/**
 * Variant URL Handler
 * Automatically selects a variant based on the ?variant= URL parameter
 * This is useful for deep-linking from external tools like equipment finder
 */

document.addEventListener('DOMContentLoaded', function() {
  // Get variant ID from URL parameter
  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get('variant');

  if (!variantId) {
    return; // No variant parameter in URL
  }

  // Wait for page to fully load
  setTimeout(function() {
    selectVariantByGID(variantId);
  }, 500);
});

function selectVariantByGID(variantGID) {
  // Extract numeric ID from GID format: gid://shopify/ProductVariant/12345
  const numericId = variantGID.split('/').pop();

  console.log('Variant URL Handler: Attempting to select variant:', variantGID, 'Numeric ID:', numericId);

  // Find the product form
  const productForm = document.querySelector('product-form form');
  if (!productForm) {
    console.warn('Variant URL Handler: Product form not found');
    return;
  }

  // Find all variant selects
  const variantSelects = document.querySelectorAll('select[id*="Option-"]');
  if (variantSelects.length === 0) {
    console.warn('Variant URL Handler: No variant select elements found');
    return;
  }

  // First try to find variant data on the page
  const variantMap = buildVariantMap();

  if (variantMap.has(numericId)) {
    // Found it on the page - use it
    console.log('Variant URL Handler: Found variant on page');
    applyVariantSelection(numericId, variantMap);
  } else {
    // Not on page - fetch from Storefront API
    console.log('Variant URL Handler: Variant not on page, fetching from API');
    fetchAndSelectVariant(variantGID, numericId);
  }
}

function applyVariantSelection(numericId, variantMap) {
  const variantSelects = document.querySelectorAll('select[id*="Option-"]');
  const optionValues = variantMap.get(numericId);

  console.log('Variant URL Handler: Applying variant selection:', optionValues);

  variantSelects.forEach((select, index) => {
    const optionValue = optionValues[index];
    if (optionValue !== undefined) {
      select.value = optionValue;
      const event = new Event('change', { bubbles: true });
      select.dispatchEvent(event);
      console.log('Variant URL Handler: Set select', index, 'to:', optionValue);
    }
  });
}

function fetchAndSelectVariant(variantGID, numericId) {
  const token = document.querySelector('meta[name="storefront-api-token"]')?.content;

  if (!token) {
    console.warn('Variant URL Handler: No storefront token found');
    return;
  }

  const query = `
    query {
      productVariant(id: "${variantGID}") {
        id
        title
        selectedOptions {
          name
          value
        }
        product {
          id
        }
      }
    }
  `;

  fetch('/api/2024-01/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': token
    },
    body: JSON.stringify({ query })
  })
  .then(r => r.json())
  .then(data => {
    if (data.errors) {
      console.error('Variant URL Handler: GraphQL errors:', data.errors);
      return;
    }

    const variant = data.data.productVariant;
    console.log('Variant URL Handler: Fetched variant from API:', variant);

    if (!variant) {
      console.warn('Variant URL Handler: Variant not found in API');
      return;
    }

    // Extract option values from selectedOptions
    const optionValues = variant.selectedOptions.map(opt => opt.value);
    console.log('Variant URL Handler: Option values from API:', optionValues);

    // Apply the selection
    const variantSelects = document.querySelectorAll('select[id*="Option-"]');
    variantSelects.forEach((select, index) => {
      const optionValue = optionValues[index];
      if (optionValue !== undefined) {
        select.value = optionValue;
        const event = new Event('change', { bubbles: true });
        select.dispatchEvent(event);
        console.log('Variant URL Handler: Set select', index, 'to:', optionValue);
      }
    });
  })
  .catch(err => {
    console.error('Variant URL Handler: Error fetching variant:', err);
  });
}

function buildVariantMap() {
  // Try to find variant data in JSON on the page
  const variantMap = new Map();

  const scripts = document.querySelectorAll('script[type="application/json"]');
  for (let script of scripts) {
    try {
      const data = JSON.parse(script.textContent);

      // Check if this is variant data with id and options
      if (data.id && (data.option1 !== undefined || data.option2 !== undefined || data.option3 !== undefined)) {
        const id = data.id.toString();
        variantMap.set(id, [data.option1, data.option2, data.option3]);
        console.log('Variant URL Handler: Found variant in page JSON:', { id, options: [data.option1, data.option2, data.option3] });
      }

      // Check if variants are in an array
      if (data.variants && Array.isArray(data.variants)) {
        data.variants.forEach(v => {
          if (v.id) {
            const id = v.id.toString();
            variantMap.set(id, [v.option1, v.option2, v.option3]);
          }
        });
      }
    } catch (e) {
      // Skip invalid JSON
    }
  }

  return variantMap;
}
